import Spacer from '@/common/components/spacer';
import HelpSmall from '@/icons/help-small';
import { Button } from '@/shadcn-ui/button';
import { cn } from '@/shadcn-ui/utils';
import { colors } from '@/theme/colors';
import { getDynamicCurrency } from '@/util-conversion/currency';

export interface MembershipLeafProps {
  gasCents: string;
  membershipCost: string;
  variant: 'top' | 'bottom' | 'all';
  PRISTINE_HERO_PDP?: boolean;
  onClickDelegate?: () => void;
}

export default function MembershipLeaf({
  gasCents,
  membershipCost,
  onClickDelegate,
  PRISTINE_HERO_PDP,
  variant,
}: MembershipLeafProps) {
  return (
    <div
      className={cn('border-solid border-flexcar-neutral80', {
        'mb-[24px] rounded-t-[24px] border-b-[1px] bg-flexcar-blue90 px-[24px] pb-[16px] pt-[24px]':
          variant === 'top',
        'mt-[24px] rounded-b-[24px] border-t-[1px] bg-flexcar-blue90 px-[24px] pb-[16px] pt-[24px]':
          variant === 'bottom',
        'rounded-[16px] border-[1px] bg-flexcar-neutral100 p-[16px]': variant === 'all',
        'bg-flexcar-neutral100 pb-[24px]': PRISTINE_HERO_PDP,
      })}
    >
      <Button
        variant="clear"
        type="button"
        onClick={onClickDelegate}
        className="flex h-fit flex-row items-center gap-[4px]"
      >
        <p
          className={cn({
            'body2-strong': variant !== 'all',
            'body2': variant === 'all',
          })}
        >
          Flexcar Membership: {getDynamicCurrency(Number(membershipCost))}/yr
        </p>
        <HelpSmall
          fillPrimary={colors.neutral1}
          className={'h-[16px] w-[16px] flex-shrink-0'}
        />
      </Button>

      <Spacer variant="height8" />
      <p
        className={cn('body2', {
          'text-flexcar-neutral50': variant === 'all',
        })}
      >
        Includes maintenance, roadside, & {gasCents}/gal savings at Sunoco. Billed after 2
        weeks, renews annually.
      </p>
    </div>
  );
}
